// No list search rides along: the page's back arrow then lands on every cluster, not on a list
// filtered to this one.
export const clusterPagePath = (name: string, tab?: string) =>
  `/clusters/${encodeURIComponent(name)}${tab ? `?${new URLSearchParams({ tab })}` : ''}`;

/** The cluster's infrastructure map: a page of its own that takes the whole screen. */
export const clusterInfraPath = (name: string) => `/clusters/${encodeURIComponent(name)}/infrastructure`;
